module.exports = __webpack_public_path__ + "static/109-9070189787813e6749f94d56a4f42169.png";